//////////// CSS /////////////
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

//////////// REACT /////////////
import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation
} from "react-router-dom";

//////////// REDUX | STORE | SERVICE /////////////
import { useSelector, useDispatch } from 'react-redux';
import { signin, signout, selectAuthen } from './store/slice/authentication';
import { getCookie } from './store/cookie';
import { HttpRequest } from './service/HttpRequest';

//////////// COMPONENT /////////////
import Header from "./component/header";
import Loading from './component/loading-bootstrap';

import { showLoad, dismissLoad } from './store/slice/loading';

////////////// PAGE ////////////////
import Login from './page/login';
import Main from './page/main';
import Enquipment from './page/enquipment';

import Maintenance from './page/maintenance';
import MaintenanceResultMT from './page/maintenance-resultmt';
import MaintenanceDashboard from './page/maintenance-dashboard';
import MaintenanceDashboardWorkorderView from "./page/maintenance-workorder-view";
import MaintenanceResultMTView from './page/maintenance-resultmt-view';
import MaintenanceStandardGas from './page/maintenance-standardgas';
import MaintenanceStandardGasLog from './page/maintenance-standardgas-log';
import MaintenanceStandardType from './page/maintenance-standardtype';

import Production from './page/production';
import ProductionChecksheet from './page/production-checksheet';
import ProductionChecksheetEnum from './page/production-checksheet-enum';
import ProductionChecksheetGroup from './page/production-checksheet-group';
import ProductionChecksheetPlan from './page/production-checksheet-plan';
import ProductionChecksheetSheet from './page/production-checksheet-sheet';
import ProductionResultPD from './page/production-resultpd';
import ProductionResultPDChecksheet from './page/production-resultpd-checksheet';
import ProductionResultPDChecksheetSurvey from './page/production-resultpd-survey';
import ProductionResultPDChecksheetSurveyTag from './page/production-resultpd-survey-tag';
import Settings from './page/settings';
import SettingsPermission from './page/settings-permission';
import SettingsUser from './page/settings-user';

function PrivateRoot({ children }) {
  const authen = useSelector(selectAuthen);
  if (authen.status) {
    return children;
  } else {
    return (<Login />);
  }
}

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function NavSurvey() {
  // We can use the `useParams` hook here to access
  // the dynamic pieces of the URL.
  let query = useQuery();

  // React.useEffect(() => {
  //   console.log(query.get("surveyno"));
  // }, []);

  return query.get("surveyno") ? (
    <Redirect to={{
      pathname: "/d-rec-admin/main/production/result-pd/checksheet/survey/tag",
      state: {
        surveyno: query.get("surveyno"),
        plantname:  "Form Link Approve",
        checksheetname: "Check sheet"
      }
    }} />
  ) : (
    null
  )
}

function App() {

  document.title = "D-REC-ADMIN";

  const dispatch = useDispatch();
  // const location = useLocation();

  React.useEffect(() => {

    dispatch(showLoad());

    let cookie_authen = getCookie("authen");
    let cookie_token = getCookie("token");

    if (cookie_authen !== "") {
      HttpRequest("/admin/checksession", {}).then(data => {
        // console.log(data.user);
        // dispatch(signin({ "token": cookie_token, user: data.user }));
        if (data.result === "OK") {
          dispatch(signin({ "token": cookie_token, user: data.user }));
        } else {
          dispatch(signout());
        }
      });
      dispatch(dismissLoad());
    } else {
      dispatch(signout());
      dispatch(dismissLoad());
    }

  });

  // React.useEffect(() => {

  //   let cookie_authen = getCookie("authen");
  //   // let cookie_token = getCookie("token");

  //   if (cookie_authen !== "") {
  //     // dispatch(dismissLoad());
  //   } else {
  //     dispatch(signout());
  //   }

  // }, [location]);

  return (
    <div className="main-content">
      <Loading></Loading>
      <Router>
        <Switch>
          <PrivateRoot>

            <Header ></Header>
            <Redirect to={{ pathname: "/d-rec-admin/main" }} />
            <Route exact path="/d-rec-admin/main" component={Main}></Route>
            <Route exact path="/d-rec-admin/main/enquipment" component={Enquipment}></Route>

            <Route exact path="/d-rec-admin/main/maintenance" component={Maintenance}></Route>
            <Route exact path="/d-rec-admin/main/maintenance/result-mt" component={MaintenanceResultMT}></Route>
            <Route exact path="/d-rec-admin/main/maintenance/dashboard" component={MaintenanceDashboard}></Route>
            <Route exact path="/d-rec-admin/main/maintenance/dashboard/workorder" component={MaintenanceDashboardWorkorderView}></Route>
            <Route exact path="/d-rec-admin/main/maintenance/result-mt/view" component={MaintenanceResultMTView}></Route>
            <Route exact path="/d-rec-admin/main/maintenance/standard-gas" component={MaintenanceStandardGas}></Route>
            <Route exact path="/d-rec-admin/main/maintenance/standard-gas/log" component={MaintenanceStandardGasLog}></Route>
            <Route exact path="/d-rec-admin/main/maintenance/standard-type" component={MaintenanceStandardType}></Route>

            <Route exact path="/d-rec-admin/main/production" component={Production}></Route>
            <Route exact path="/d-rec-admin/main/production/checksheet" component={ProductionChecksheet}></Route>
            <Route exact path="/d-rec-admin/main/production/checksheet/enum" component={ProductionChecksheetEnum}></Route>
            <Route exact path="/d-rec-admin/main/production/checksheet/group" component={ProductionChecksheetGroup}></Route>
            <Route exact path="/d-rec-admin/main/production/checksheet/plan" component={ProductionChecksheetPlan}></Route>
            <Route exact path="/d-rec-admin/main/production/checksheet/sheet" component={ProductionChecksheetSheet}></Route>
            <Route exact path="/d-rec-admin/main/production/result-pd" component={ProductionResultPD}></Route>
            <Route exact path="/d-rec-admin/main/production/result-pd/checksheet" component={ProductionResultPDChecksheet}></Route>
            <Route exact path="/d-rec-admin/main/production/result-pd/checksheet/survey" component={ProductionResultPDChecksheetSurvey}></Route>
            <Route exact path="/d-rec-admin/main/production/result-pd/checksheet/survey/tag" component={ProductionResultPDChecksheetSurveyTag}></Route>

            <Route exact path="/d-rec-admin/main/settings" component={Settings}></Route>
            <Route exact path="/d-rec-admin/main/settings/permission" component={SettingsPermission}></Route>
            <Route exact path="/d-rec-admin/main/settings/user" component={SettingsUser}></Route>


            <Route exact path="/d-rec-admin" component={NavSurvey}></Route>

          </PrivateRoot>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
